module.exports = __webpack_public_path__ + "media/icons/offer-details-przod@3x-7e7da7bf.svg";